import { z } from "zod";

/**
 * Full tldraw geo vocabulary (GeoShapeGeoStyle). Toolbar shows a subset;
 * the agent can use every type the editor supports.
 */
export const BOARD_GEO_SHAPE_TYPES = [
	"rectangle",
	"ellipse",
	"oval",
	"triangle",
	"diamond",
	"rhombus",
	"rhombus-2",
	"pentagon",
	"hexagon",
	"octagon",
	"star",
	"heart",
	"cloud",
	"trapezoid",
	"check-box",
	"x-box",
	"arrow-right",
	"arrow-left",
	"arrow-up",
	"arrow-down",
] as const;

export const agentGeoTypeSchema = z.enum(BOARD_GEO_SHAPE_TYPES);

export const agentGeoColorSchema = z.enum([
	"black",
	"grey",
	"light-violet",
	"violet",
	"blue",
	"light-blue",
	"yellow",
	"orange",
	"green",
	"light-green",
	"light-red",
	"red",
	"white",
]);

export const agentGeoFillSchema = z
	.enum(["none", "semi", "solid", "pattern", "fill"])
	.describe("Geo fill: none outline, semi translucent, solid/fill opaque");

export const agentGeoFontSchema = z
	.enum(["draw", "sans", "serif", "mono"])
	.describe("Label font inside the geo shape");

export const agentGeoAlignSchema = z
	.enum(["start", "middle", "end"])
	.describe("Horizontal label alignment");

export const agentGeoVerticalAlignSchema = z
	.enum(["start", "middle", "end"])
	.describe("Vertical label alignment");

export type AgentGeoType = z.infer<typeof agentGeoTypeSchema>;
export type AgentGeoColor = z.infer<typeof agentGeoColorSchema>;
export type AgentGeoFill = z.infer<typeof agentGeoFillSchema>;
export type AgentGeoFont = z.infer<typeof agentGeoFontSchema>;
export type AgentGeoAlign = z.infer<typeof agentGeoAlignSchema>;
export type AgentGeoVerticalAlign = z.infer<typeof agentGeoVerticalAlignSchema>;
